import {FRBase} from "#Formulas/FormulaCore/FRBase";
import {FRFor} from "#Formulas/FormulaCore/Elements/FRFor";

export class FRUtilities{
    public static SanitizeNumber(val:any,defaultValue=0)
    {
        if(val==null)
            return defaultValue;

        if(val?.IsField)
            return val.GetNumber();

        if(isNaN(val))
            return defaultValue;

        return Number(val);

    }

    public static NotifyReturnToParent(element:FRBase)
    {
        while (['BLO','MA','FOR','FE'].indexOf(element.Parent.Options.T)<0)
        {
            element=element.Parent;
        }

        (element.Parent as any).ReturnWasExecuted();
    }

    public static NotifyBreakToParent(element:FRBase)
    {
        while (['FOR','FE'].indexOf(element.Parent.Options.T)<0)
        {
            element=element.Parent;
        }

        (element.Parent as any).BreakWasExecuted();
    }
}